import { AbstractControl, ValidatorFn } from "@angular/forms";

export function maxPlainTextLength( maxPlainTextLength: number ): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== null && ( control.value.replace(/<\/?[^>]+(>|$)/g, "").trim().length > maxPlainTextLength )) {
      return { 'maxPlainTextLength': true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/common/validators/maxPlainTextLengthValidator.ts